import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
    BaseControl,
    Textbox,
    Radio,
    Dropdown,
    TextArea,
    Typeahead,
    DateTimePicker
} from '../../../shared/dynamic-form';

@Injectable()
export class SpecialDaysFormService {
    constructor() { }
    /**
     * genera los controles dinamicos de el formulario de dias festivos
     * y setea sus valores
     *
     * @param {*} [objectModel]
     * @returns {BaseControl<any>[]}
     * @memberof SpecialDaysFormService
     */
    getFieldsHolidays(objectModel?: any): BaseControl<any>[] {
        // se inicializa una variable de tipo Date para el control de datepiker
        let fecha: Date;
        // se valida si al formulario se envian valores para los controles
        if (objectModel != null) {
            // damos formato a la variable de valor del formulario para la fecha
            fecha = this.formatDate(objectModel.fecha);
        }
        const controls: BaseControl<any>[] = [
            new DateTimePicker({
                key: 'dtfecha',
                label: 'Fecha:',
                order: 1,
                pickerType: 'calendar',
                placeholder: 'Selecione una fecha',
                value: objectModel ? fecha : null,
                validations: {
                    validators: [Validators.required]
                }
            }),
            new TextArea({
                key: 'txtMotivo',
                label: 'Motivo:',
                rows: '2',
                notResize: false,
                value: objectModel ? objectModel.nombre : null,
                order: 2,
                placeholder: 'Motivo del dia festivo...',
                validations: {
                    validators: [
                        Validators.required
                    ]
                }
            }),
        ];

        return controls.sort((a, b) => a.order - b.order);
    }
    /**
     * genera los controles dinamicos de el formulario de dias especiales
     *
     * @param {*} [objectModel]
     * @returns {BaseControl<any>[]}
     * @memberof SpecialDaysFormService
     */
    getFieldsSpecialDays(objectModel?: any): BaseControl<any>[] {
        // se inicializa una variable de tipo Date para el control de datepiker
        let fecha: Date;
        // se valida si al formulario se envian valores para los controles
        if (objectModel != null) {
            // damos formato a la variable de valor del formulario para la fecha
            fecha = this.formatDate(objectModel.fecha);
        }
        const controls: BaseControl<any>[] = [
            new DateTimePicker({
                key: 'dtfecha',
                label: 'Fecha:',
                order: 1,
                pickerType: 'calendar',
                placeholder: 'Selecione una fecha',
                value: objectModel ? fecha : null,
                validations: {
                    validators: [Validators.required]
                }
            }),
            new TextArea({
                key: 'txtMotivo',
                label: 'Motivo:',
                rows: '2',
                notResize: false,
                value: objectModel ? objectModel.nombre : null,
                order: 2,
                placeholder: 'Motivo del dia especial...',
                validations: {
                    validators: [
                        Validators.required
                    ]
                }
            }),
            new Dropdown({
                key: 'cboTipoDia',
                label: 'Tipo de día:',
                options: [
                    { key: 'true', value: 'Laboral' },
                    { key: 'false', value: 'No laboral' },
                ],
                value: objectModel ? objectModel.cboTipo : null,
                order: 3,
                validations: {
                    validators: [Validators.required]
                }
            }),
        ];

        return controls.sort((a, b) => a.order - b.order);
    }
    /**
     * retorna una dato tipo Date seteado posteriormente por una variable con la fecha que se desea crear
     * esta variable debe tener el formato de fecha DD/MM/AAAA de lo contrario no funcionara
     *
     * @private
     * @param {string} date
     * @returns {Date}
     * @memberof SpecialDaysFormService
     */
    private formatDate(date: string): Date {
        // se inicializa una variable de tipo Date para el control de datepiker
        const dateF: Date = new Date();
       // se corta la cadena que viene con la fecha por un parametro en coincidencia que en este caso es el '/'
       const f = date.split('/');
       // creamos una variable para encapsular el dia
       const day = Number(f[0]);
       // creamos una variable para encapsular el mes como un numero y poder restarle 1
       // esto se debe a que los meses son por posiciones iniciando en 0 por lo tanto 0 es enero y etc
       const month = Number(f[1]) - 1;
       // creamos una variable para encapsular el año
       const year = Number(f[2]);
       // seteamos el año, mes y dia a la variable tipo Date creada inicialmente con los valores enviados
       dateF.setFullYear(year);
       dateF.setMonth(month);
       dateF.setDate(day);

       return dateF;
    }
}



// WEBPACK FOOTER //
// ./src/app/administration/special-days/shared/special-days-form.service.ts